﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { IPlaneNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.PlaneNode,
})
export class PlaneNode extends PrimitiveMeshNode implements IPlaneNode {
    public constructor() {
        super();
    }
    public depth: number;
    public width: number;
    public segments: number;
}

export function isPlaneMesh(node: Kb3dObject): node is PlaneNode {
    return instanceOf(node, Token.PlaneNode);
}
